import home from '../../../assest/contactA.png'
import call from '../../../assest/contactB.png'
import message from '../../../assest/contactC.png'

const contactArr = [
    {
       contactLogo:home,
       headings:'Our Location',
       details:'Khasra No 89, Khata No 1950, Krishana Chowk, Palam Vihar, Gurgaon, Palam Vihar, Haryana, India'
    },
    {
        contactLogo:call,
        headings:'Phone Number',
        details:'7992921414'
     },
     {
        contactLogo:message,
        headings:'Email Address',
        details:'support@ppimpl.com'
     },

   
]
export default contactArr;